import { ReactNode } from 'react';

import { useAccountBillingType } from '@/src/hooks/useAccountBillingType';

type Props = {
  children: ReactNode;
};

export const PaymOnly = ({ children }: Props) => {
  const { data } = useAccountBillingType();
  return data?.type === 'PAYM' ? children : null;
};

export const PaygOnly = ({ children }: Props) => {
  const { data } = useAccountBillingType();
  return data?.type === 'PAYG' ? children : null;
};
